import {View, Text} from 'native-base';
import React from 'react';

import MaskTitle from './MaskTitle';
import MirroredGradient from './MirroredGradient';

export interface SecurityMaskPropTypes {
  title?: string;
  showAsterisk?: boolean;
  asteriskLength?: number;
}

/**
 * Currently this is the most used combination, so defaults are set based on that.
 * This can be made more custom, but as of now there is no reason to prop drill for 1 instance.
 *
 * For the one-off, manually pull in the MirroredGradient and the MaskTitle in the single place it is needed.
 */

const SecurityMask: React.FC<SecurityMaskPropTypes> = ({
  title,
  showAsterisk = false,
  asteriskLength = 12,
}) => {
  return (
    <View>
      {title && <MaskTitle title={title} uppercase />}
      {showAsterisk && <Text>{'*'.repeat(asteriskLength)}</Text>}
      {!showAsterisk && <MirroredGradient />}
    </View>
  );
};

export default SecurityMask;
